// @flow
import { withDependencies } from 'app/rgs/utils/with-dependencies';
import { APP_SERVICES_API, APP_SERVICES_REST_API } from 'app/rgs/constants';

import { Service } from 'app/rgs';
import type { IApi } from 'app/rgs/api/api';

// Базовый класс для сервисов Личного кабинета
@withDependencies({
	services: [
		APP_SERVICES_REST_API,
		APP_SERVICES_API,
	],
})
export default class BaseService
	extends Service {

	// Rest api
	_api: IApi;
	_baseApi: IApi;

	constructor (api: IApi, baseApi: IApi) {
		super();

		this._api = api;
		this._baseApi = baseApi;
	}
}
